export const BASE_URL = "/auth-api";
